// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Icon: MarkdocTagRegistration = {
  tag: 'icon',
  component: 'Icon',
  selfClosing: true,
  attributes: {
    type: {
      type: String,
      required: true,
      description: 'The Sail icon name for this icon',
    },
    color: {
      type: String,
      default: 'gray',
      description: 'The Sail color for this icon',
    },
    size: {
      type: Number,
      default: 16,
      description: 'The Sail icon size',
    },
    alt: {
      type: String,
      localizable: true,
      description:
        'By default, the Icon will be hidden. Provide alt text if it is not used for purely decorative purposes.',
    },
  },
};
